module.exports = __webpack_public_path__ + "images/sprites/ui/icon_phone_blue_edf698f62d3c8ee06fbd5cfe15b55744.png";